import type { NextRouter } from 'next/router';

/** Follow a notification link: `#id` scrolls on the page, absolute URLs load, paths use the router. */
export function openNotificationUrl(url: string, router: Pick<NextRouter, 'push'>): void {
  if (url.startsWith('#')) {
    document.getElementById(url.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    return;
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    window.location.assign(url);
    return;
  }
  void router.push(url);
}
